import { render } from "./AIDocumentContent.vue?vue&type=template&id=559f5d5b&scoped=true"
import script from "./AIDocumentContent.vue?vue&type=script&lang=js"
export * from "./AIDocumentContent.vue?vue&type=script&lang=js"

import "./AIDocumentContent.vue?vue&type=style&index=0&id=559f5d5b&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-559f5d5b"]])

export default __exports__